import z from 'zod'
import { Model } from '../../_kernel/architecture'
import type { Availability } from './Availability'
import { Rate } from './Rate'
import type { Currencies } from '../../_kernel/Currency'
import type { PaymentPolicies } from './PaymentPolicy'
import { BoardCode } from './BoardCode'

export const CriteriaAvailabilityValidation = z.object({
  rate: z.instanceof(Rate),
  boardCode: z.instanceof(BoardCode),
})

export class CriteriaAvailability extends Model {
  static create({ rate, boardCode }: z.infer<typeof CriteriaAvailabilityValidation>) {
    CriteriaAvailabilityValidation.parse({ rate, boardCode })
    return new CriteriaAvailability(rate, boardCode)
  }

  static fromLiterals({
    paymentPolicy,
    cancellationPolicyFromDate,
    cancellationPolicyAmount,
    currency,
    boardCode,
  }: {
    paymentPolicy: PaymentPolicies
    cancellationPolicyFromDate?: string
    cancellationPolicyAmount?: number
    currency?: Currencies
    boardCode: string
  }) {
    return CriteriaAvailability.create({
      rate: Rate.fromLiterals({
        paymentPolicy,
        cancellationPolicyFromDate,
        cancellationPolicyAmount,
        currency,
      }),
      boardCode: BoardCode.fromLiteral(boardCode),
    })
  }

  static fromJSON(json: ReturnType<CriteriaAvailability['toJSON']>) {
    return CriteriaAvailability.create({
      rate: Rate.fromJSON(json.rate),
      boardCode: BoardCode.create({ value: json.boardCode }),
    })
  }

  constructor(
    private readonly _rate: Rate,
    private readonly _boardCode: BoardCode
  ) {
    super()
  }

  equals(availability: Availability) {
    return (
      this._rate.cancellationPolicyFromDate() === availability.cancellationPolicyFromDate() && // prettier-ignore
      this._rate.cancellationPolicyAmount() === availability.cancellationPolicyAmount() && // prettier-ignore
      this._rate.paymentPolicy() === availability.paymentPolicy() && // prettier-ignore
      this._boardCode.value() === availability.boardCode()
    )
  }

  toJSON() {
    return {
      rate: this._rate.toJSON(),
      boardCode: this._boardCode.value(),
    }
  }
}
